import getUniverse from "./actions/get_universe";

export default {
    getUniverse
};
